import { render, staticRenderFns } from "./UnidentifiedObjectDanger.vue?vue&type=template&id=3ad1cbb8&"
import script from "./UnidentifiedObjectDanger.vue?vue&type=script&lang=js&"
export * from "./UnidentifiedObjectDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports